import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "~/components/sections/Hero";
import { Problem } from "~/components/sections/Problem";
import { HowItWorks } from "~/components/sections/HowItWorks";
import { Showcase } from "~/components/sections/Showcase";
import { Differentiator } from "~/components/sections/Differentiator";
import { BuiltByKugie } from "~/components/sections/BuiltByKugie";
import { Productivity } from "~/components/sections/Productivity";
import { FAQ } from "~/components/sections/FAQ";
import { Closer } from "~/components/sections/Closer";

export const Route = createFileRoute("/")({
  component: LandingPage,
});

function LandingPage() {
  return (
    <>
      <Hero />
      <Problem />
      <HowItWorks />
      <Showcase />
      <Differentiator />
      <BuiltByKugie />
      <Productivity />
      <FAQ />
      <Closer />
    </>
  );
}
